import { useNavigate, useParams } from "react-router-dom";
import { ControlList, Dialog, useListGraphqlQuery, useTranslationRoute, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useCallback } from "react";
import _ from "lodash";
import { useBankQuery } from "../../details/hooks/useBankQuery";
import { BANK_LIST_ID } from "../../../container/BankListContainer";
import { useBankCreateForm } from "../hooks/useBankCreateForm";

export const BankCreateContainer = () => {
    const [
        TITLE,
        EDIT
    ] = useTranslations(i18n);
    const urlParams = useUrlParamsValueToString()
    const { bankId } = useParams()
    const tr = useTranslationRoute()
    const navigate = useNavigate()
    const control = useBankCreateForm(bankId ? parseInt(bankId) : undefined)
    const { invalidateQuery } = useListGraphqlQuery(BANK_LIST_ID);
    const { invalidateQuery: invalidateDetailsQuery } = useBankQuery(bankId ? parseInt(bankId) : undefined)
 
    const isEdit = !_.isEmpty(bankId)

    const handleSubmited = useCallback(() => {
        invalidateDetailsQuery()
        invalidateQuery()
        if(isEdit) {
            navigate(tr(`admin/students/viewer/bank/${bankId}?${urlParams}`))
            return
        }
        navigate(`..?${urlParams}`)
    }, [invalidateQuery])

    const handleClose = useCallback(() => {
        navigate(tr(`admin/students/viewer/bank?${urlParams}`))
    }, [])

    return (
        <Dialog open title={!isEdit ? "Create a bank" : "Edit a bank"} onClose={handleClose}>
            <ControlList
                {...control}
                defaultValue={{
                    id: parseInt(bankId),
                }}
                onCancel={handleClose}
                onSubmited={handleSubmited}
            />
        </Dialog>
    );
}

const i18n = [
    "Bsm.Students.Bank.Create.Title",
    "Bsm.Students.Bank.Edit.Title"
];